<div class="container">
  <div class="pb-4">
    <p class="header_status attr__lbl_title pb-3">
      Convide seus amigos e ganhe recompensas
    </p>
    <label class="header_status attr__lbl">
      Que tal convidar seus amigos apaixonados por chocolate para se tornarem
      Cacau Lovers? Convide quantos amigos quiser.
    </label>
    <label class="header_status attrl_lbl_subtitle">
      Verifique se não há um desafio de indicação de amigos vigente para você
      acumular mais Cacaus.
    </label>
  </div>

  <div class="pb-5" *ngIf="!this.membro">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        'border-radius': '16px',
        width: '50%',
        height: '50px',
        margin: '9px 8px 0 0'
      }"
    ></ngx-skeleton-loader>
  </div>

  <div class="div__form pb-5" *ngIf="this.membro">
    <div class="div__indicacoes">
      <div
        class="border_indicacoes mb-3"
        (click)="enviarLinkWhats(this.PAGE_HOME)"
      >
        <img
          class="img__indicacoes"
          src="assets/images/icons/WhatsIndicacoes.png"
          alt=""
        />
        <p>Whatsapp</p>
      </div>

      <div id="copiarLink" class="border_indicacoes mb-3" (click)="copiarLink(this.PAGE_HOME)">
        <img
          class="img__indicacoes"
          src="assets/images/icons/CopyText.png"
          alt=""
        />
        <p>Copiar link</p>
      </div>
      <div
        class="border_indicacoes mb-3"
        (click)="controlePainel()"
        [ngClass]="{ border_focus: collapseAberto }"
      >
        <img
          class="img__indicacoes_email"
          src="assets/images/icons/Email.png"
          alt=""
        />
        <p>E-mail</p>
      </div>
    </div>
    <div
      class="div__enviar_email"
      [ngClass]="{ 'form-email--aberto': collapseAberto }"
    >
      <!-- <input placeholder="Digite os endereços de e-mails aqui..." type="text" /> -->
      <div class="lovers-input__container">
        <!-- <ngx-tags-input
          class="lovers-input lovers-input"
          name="email"
          id="email"
          [mode]="'success'"
          [rounded]="true"
          #email
          [placeholder]="'Digite os endereços de e-mails aqui..'"
          (tagsChange)="displayTags($event)"
        >
        </ngx-tags-input> -->
        <div>
          <ngx-tags-input
            [ngClass]="{ 'error-email': exibeMensagemEmailObrigatorio }"
            class="ngx-tag"
            #email
            id="email"
            [limit]="25"
            name="email"
            [placeholder]="'Digite os endereços de e-mails aqui..'"
            [tags]="emails"
            [rounded]="true"
            (tagsChange)="displayTags($event)"
          ></ngx-tags-input>
        </div>
        <small
          class="text-danger lovers-font--bold"
          *ngIf="exibeMensagemEmailObrigatorio"
        >
          Esse campo é obrigatório!
        </small>
      </div>
      <button
        (click)="enviarEmail(this.PAGE_HOME)"
        class="lovers-button"
        [disabled]="btnDisabled"
        [ngClass]="{ 'lovers--disabled': btnDisabled }"
      >
        Convidar
        <i *ngIf="btnDisabled" class="fa fa-spinner fa-spin"></i>
      </button>
      <span>
        Separe múltiplos endereços de e-mail pela tecla
        <strong>“Enter”</strong>
      </span>
    </div>
  </div>

  <div class="pb-4">
    <p class="p__invite_company attr__lbl_title pb-3">
      Você também pode convidar empresas!
    </p>
    <label class="header_status attr__lbl">
      Convide aquela empresa que você adora para juntos compartilharmos momentos
      especiais.
    </label>
  </div>

  <div class="pb-5" *ngIf="!this.membro">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        'border-radius': '16px',
        width: '70%',
        height: '50px',
        margin: '9px 8px 0 0'
      }"
    ></ngx-skeleton-loader>
  </div>

  <div class="div__form pb-5" *ngIf="this.membro">
    <div>
      <div class="div__indicacoes">
        <div
          class="border_indicacoes mb-3"
          (click)="enviarLinkWhats(this.PAGE_PARCEIROS)"
        >
          <img
            class="img__indicacoes"
            src="assets/images/icons/WhatsIndicacoes.png"
            alt=""
          />
          <p>Whatsapp</p>
        </div>
        <div
          id="copiarLinkIndicacao"
          class="border_indicacoes mb-3"
          (click)="copiarLink(this.PAGE_PARCEIROS)"
        >
          <img
            class="img__indicacoes"
            src="assets/images/icons/CopyText.png"
            alt=""
          />
          <p>Copiar link</p>
        </div>
        <div class="border_indicacoes mb-3" (click)="irParaPaginaCadastro()">
          <img
            class="img__indicacoes"
            src="assets/images/icons/Form.png"
            alt=""
          />
          <p>Cadastrar minha empresa</p>
        </div>
        <div
          *ngIf="false"
          class="border_indicacoes mb-3"
          (click)="controlePainelEmpresa()"
          [ngClass]="{ border_focus: collapseAbertoEmpresa }"
        >
          <img
            class="img__indicacoes_email"
            src="assets/images/icons/Email.png"
            alt=""
          />
          <p>E-mail</p>
        </div>
      </div>
      <div
        *ngIf="false"
        class="div__enviar_email"
        [ngClass]="{ 'form-email--aberto': collapseAbertoEmpresa }"
      >
        <div class="lovers-input__container">
          <ngx-tags-input
            class="lovers-input"
            name="email"
            id="email"
            #email
            placeholder="Digite os endereços de e-mails aqui.."
            (onTagsChanged)="onTagsCompanyChanged($event)"
          >
          </ngx-tags-input>
          <small
            class="text-danger lovers-font--bold"
            *ngIf="exibeMensagemEmailEmpresaObrigatorio"
          >
            Esse campo é obrigatório!
          </small>
        </div>
        <button
          (click)="enviarEmail()"
          class="lovers-button"
          [disabled]="btnDisabledEmpresa"
          [ngClass]="{ 'lovers--disabled': btnDisabledEmpresa }"
        >
          Convidar
          <i *ngIf="btnDisabledEmpresa" class="fa fa-spinner fa-spin"></i>
        </button>
        <span>
          Separe múltiplos endereços de e-mail pela tecla
          <strong>“Enter”</strong>
        </span>
      </div>
    </div>
  </div>

  <div>
    <div class="pb-4">
      <p class="header_status attr__lbl_title pb-3">Suas indicações</p>
      <label
        class="header_status attr__lbl"
        *ngIf="this.indicacoes?.length > 0"
      >
        Essas são as pessoas que aceitaram o seu convite.
      </label>
    </div>

    <div *ngFor="let item of this.indicacoes">
      <div class="tbl__convidados">
        <label class="header_status attr__lbl">{{ item.nome }}</label>
        <label class="header_status attr__lbl color__gray right">{{
          item.dataInclusao | date : "dd/MM/yyyy"
        }}</label>
      </div>
      <hr class="tbl__hr" />
    </div>
  </div>

  <div style="text-align: center" *ngIf="this.indicacoes?.length == 0">
    <img
      src="assets/images/icons/sem_indicacoes.png"
      class="sem__movimentacao__icone"
    />
    <p class="header_status attr__lbl_title pb-3" style="color: black">
      Convide seus amigos
    </p>
    <label class="header_status attr__lbl">
      Você ainda não indicou nenhum amigo...
    </label>
  </div>
</div>
<img
  class="background__imagem__footer"
  src="assets/images/backgrounds/background_gradiente_cima.png"
/>
